import { makeAutoObservable } from 'mobx'

export type SyncedFile = {
	filename: string
	detectedAt: Date
}

class FolderSyncStore {
	private startWatchingCallback: ( () => void ) | null = null
	watchingStarted = false

	isWatching = false
	folderName: string | null = null
	syncedFiles: SyncedFile[] = []
	hasSubfolders = false

	intervalHandle: ReturnType<typeof setInterval> | null = null
	activeDirHandle: object | null = null
	trackedMap: Map<string | number, unknown> = new Map()
	seenFilenamesMap: Map<string, string | null> = new Map()
	assetUploadsCache: unknown = null
	subfolderVbIdMap: Map<string, number> = new Map()
	pendingSyncedFiles: Array<{ filename: string, folder_id: number }> = []

	constructor() {
		makeAutoObservable( this, {
			intervalHandle: false,
			activeDirHandle: false,
			trackedMap: false,
			seenFilenamesMap: false,
			assetUploadsCache: false,
			subfolderVbIdMap: false,
			pendingSyncedFiles: false
		} )
	}

	get isFolderSyncSupported() {
		return 'showDirectoryPicker' in window
	}

	setStartWatching( fn: () => void ) {
		this.startWatchingCallback = fn
	}

	unsetStartWatching() {
		this.startWatchingCallback = null
	}

	triggerStartWatching() {
		this.startWatchingCallback?.()
	}

	setWatchingStarted( value: boolean ) {
		this.watchingStarted = value
	}

	setIsWatching( value: boolean ) {
		this.isWatching = value
	}

	setFolderName( name: string | null ) {
		this.folderName = name
	}

	setSyncedFiles( files: SyncedFile[] ) {
		this.syncedFiles = files
	}

	updateSyncedFiles( updater: ( prev: SyncedFile[] ) => SyncedFile[] ) {
		this.syncedFiles = updater( this.syncedFiles )
	}

	setHasSubfolders( value: boolean ) {
		this.hasSubfolders = value
	}
}

export default FolderSyncStore
